import service from '@/services/inventario/entrada'

const getDefaultState = () => ({
  entrada: { tipo: '', causa: '', cuentaContable: '' },

  entradaDefault: [
    { tipo: 'Entrada Controlada', causa: ['Compra', 'Producción', 'Regalo', 'Sobrante', 'Traslado', 'Reintegro', 'Recuperación', 'Reparación', 'Otro'] },
    { tipo: 'Entrada Sin Control', causa: ['Error Humano', 'Residuo', 'Otro'] }
  ],

  lista: [], // lista de tipos de entrada (gestion entrada)
  currentRow: null,
  saved: 'null'
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => (state.entrada = { ...getDefaultState().entrada }),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET: (state, obj) => {
    const causa = obj.causa.join('\n')
    state.entrada = { ...obj, causa }
    state.saved = true
  },
  SET_LIST: (state, obj) => {
    state.lista = obj //[...new Set([...state.lista.map(JSON.stringify), ...obj.map(JSON.stringify)])].map(JSON.parse)
  },
  UPDATE_LIST: (state, obj) => {
    const nObj = state.lista.find(e => e._id === obj._id)
    if (!nObj) state.lista = [obj, ...state.lista]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))

    state.saved = true
  },
  DELETE_LIST: (state, { obj }) => {
    state.lista = state.lista.filter(e => e._id !== obj._id)
  },
  SAVE_CHANGES: (state, obj) => {
    state.entrada = obj
    state.saved = false
  }
}

export const actions = {
  create: async ({ commit, rootGetters }, input) => {
    const accountingModule = rootGetters['facturacion/emisorStore/getAccountingModule']
    if (!accountingModule) delete input.cuentaContable

    return service
      .create({
        ...input,
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => {
        commit('UPDATE_LIST', {
          ...input,
          _id: result._id
        })

        return result
      })
  },
  entrada: async ({ commit, rootGetters }, input) => {
    const accountingModule = rootGetters['facturacion/emisorStore/getAccountingModule']

    return service
      .entrada(
        {
          ...input,
          cantidad: Number(input.cantidad),
          costoUnitario: Number(input.costoUnitario),
          emisor: {
            _id: await rootGetters['facturacion/emisorStore/get_Id']
          }
        },
        accountingModule
      )
      .then(result => {
        commit(
          'inventario/mermaStore/UPDATE_CONTROL_MERMA_LIST',
          {
            ...input,
            _id: result._id
          },
          { root: true }
        )

        return result
      })
  },
  readById: async ({ commit }, input) => commit('SET', input),
  resetList: ({ state }) => (state.listaa = []),
  readAllByEmisor: async ({ commit, state, dispatch, rootGetters }, force = false) => {
    if (state.lista.length && !force) return state.lista

    state.lista = []

    const accountingModule = rootGetters['facturacion/emisorStore/getAccountingModule']

    if (accountingModule) {
      await dispatch('contabilidad/accountStore/readAllByEmisor', { restart: false }, { root: true }).catch(() => {})
    }

    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id']).then(result => {
      // si es una nueva lista, asigna los valores por defecto y los guarda.
      if (!result.length) {
        // busca la cuenta contable default
        if (accountingModule) {
          const cuenta = rootGetters['contabilidad/accountStore/getAccountByType']('Costos de inventario')

          if (cuenta.length) {
            const defaultAccount = cuenta?.find(account => account.sysName === 'Ajuste de inventario')

            state.entradaDefault.forEach(item => {
              item.cuentaContable = defaultAccount?._id
            })
          }
        }

        state.entradaDefault.forEach(item => dispatch('create', item))
      } else commit('SET_LIST', result)

      return true
    })
  },
  delete: ({ commit }, { items }) =>
    service.delete(items).then(result => {
      result.forEach(i => {
        if (i.state) commit('DELETE_LIST', { obj: i })
      })
      return result
    }),

  saveChanges: ({ commit }, input) => commit('SAVE_CHANGES', input)
}

// export const getters = {
//   get: state => entrada => {
//     return state.listaa.find(e => e._id === entrada._id)
//   }
// }
